import { render, staticRenderFns } from "./Optical.vue?vue&type=template&id=4d795e4c"
import script from "./Optical.vue?vue&type=script&lang=js"
export * from "./Optical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports